import React, { useState, useEffect } from 'react';
import api from '../utils/api';

const statusBadge = (s) => {
  const map = { present:'badge-green', absent:'badge-red', leave:'badge-blue', holiday:'badge-yellow' };
  return <span className={`badge ${map[s]||'badge-gray'}`}>{s?.replace('_',' ') || 'Not recorded'}</span>;
};

export default function TeamView() {
  const [records, setRecords] = useState([]);
  const [date, setDate]       = useState(new Date().toISOString().split('T')[0]);
  const [loading, setLoading] = useState(false);

  useEffect(() => { fetchData(); }, [date]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await api.get(`/attendance/team?date=${date}`);
      setRecords(res.data);
    } catch (err) { console.error(err); }
    finally { setLoading(false); }
  };

  const present  = records.filter(r => r.status === 'present').length;
  const absent   = records.filter(r => r.status === 'absent').length;
  const onLeave  = records.filter(r => r.status === 'leave').length;
  const wfh      = records.filter(r => r.is_wfh).length;

  return (
    <div>
      <div className="flex-between mb-16">
        <h1 className="page-title" style={{marginBottom:0}}>Team Attendance</h1>
        <input className="form-control" type="date" style={{width:180}}
          value={date} onChange={e => setDate(e.target.value)}/>
      </div>

      <div className="stat-grid">
        <div className="stat-card"><div className="stat-num" style={{color:'var(--success)'}}>{present}</div><div className="stat-label">Present</div></div>
        <div className="stat-card"><div className="stat-num" style={{color:'var(--danger)'}}>{absent}</div><div className="stat-label">Absent</div></div>
        <div className="stat-card"><div className="stat-num" style={{color:'#1d4ed8'}}>{onLeave}</div><div className="stat-label">On Leave</div></div>
        <div className="stat-card"><div className="stat-num">{wfh}</div><div className="stat-label">WFH</div></div>
      </div>

      <div className="card">
        <div className="card-title">Team for {new Date(date).toLocaleDateString('en-IN',{weekday:'long',day:'2-digit',month:'long',year:'numeric'})}</div>
        {loading ? <div className="loading">Loading...</div> : (
          <div className="table-wrap">
            <table>
              <thead><tr><th>Employee</th><th>Department</th><th>Check In</th><th>Check Out</th><th>Regular Hrs</th><th>Overtime</th><th>WFH</th><th>Status</th></tr></thead>
              <tbody>
                {records.length === 0 && <tr><td colSpan="8" className="text-center text-muted" style={{padding:24}}>No attendance records for this date</td></tr>}
                {records.map(r => (
                  <tr key={r.id||r.employee_id}>
                    <td style={{fontWeight:500}}>{r.full_name}</td>
                    <td>{r.department || '—'}</td>
                    <td>{r.check_in ? new Date(r.check_in).toLocaleTimeString('en-IN',{hour:'2-digit',minute:'2-digit'}) : '—'}</td>
                    <td>{r.check_out ? new Date(r.check_out).toLocaleTimeString('en-IN',{hour:'2-digit',minute:'2-digit'}) : '—'}</td>
                    <td>{r.regular_hours || 0}h</td>
                    <td>{r.overtime_hours > 0 ? <span style={{color:'var(--success)',fontWeight:600}}>+{r.overtime_hours}h</span> : '—'}</td>
                    <td>{r.is_wfh ? '🏡' : '—'}</td>
                    <td>{statusBadge(r.status)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
